export const NAME = 'archive';
